module.exports = __webpack_public_path__ + "img/badaling.57ed68f5.png";